import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, TrendingDown, Video, BoxIcon } from 'lucide-react';
const problems = [{
  icon: MessageSquare,
  title: 'Explicas bien, pero...',
  description: 'No te toman en serio.'
}, {
  icon: BoxIcon,
  title: 'Tu mensaje se pierde',
  description: 'Aunque tengas razón, no logras impactar.'
}, {
  icon: TrendingDown,
  title: 'Te gana la presión',
  description: 'Cuando toca presentar o vender, los nervios te traicionan.'
}, {
  icon: Video,
  title: 'En cámara no transmites',
  description: 'Sientes que no proyectas lo que realmente vales.'
}];
export function ProblemSection() {
  return <section className="py-24 bg-[#F5F1E8]" data-id="element-371">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-372">
        <div className="text-center mb-16" data-id="element-373">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold text-[#1a3a52] mb-4" data-id="element-374">
            La promesa clara
          </motion.h2>
          <div className="w-24 h-1 bg-[#C9A961] mx-auto rounded-full mb-6" data-id="element-375" />
          <p className="text-xl text-gray-600 font-medium" data-id="element-376">
            Si hoy sientes que:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-377">
          {problems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300 h-full flex flex-col items-center text-center" data-id="element-378">
              <div className="w-14 h-14 bg-red-50 rounded-full flex items-center justify-center mb-6" data-id="element-379">
                <item.icon className="w-7 h-7 text-red-500" data-id="element-380" />
              </div>
              <h3 className="text-xl font-bold text-[#1a3a52] mb-3" data-id="element-381">
                {item.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-382">
                {item.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto" data-id="element-383">
          <p className="text-xl md:text-2xl text-[#1a3a52] font-medium leading-relaxed" data-id="element-384">
            Este pack te da un sistema completo para entrenar presencia:
            <br data-id="element-385" />
            <span className="text-[#C9A961] font-bold mt-2 block" data-id="element-386">
              mensaje + aura + cuerpo + voz + historias + escenario + set.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}